// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"1fd06ae0","453":"68d2f560","917":"5d2fa9cf"}[chunkId] + ".chunk.js";
};